import {
  imageBasePath,
} from '../../library/constants';

import { data } from '../../version/dataVersion.js';

// const flip = 'flip/';
const node = 'node/';
const choices = 'choices/';
const match = 'match/';
const move = 'move/';




/*
 *
 *
 *
 * flip
 *
 *
 *
 */

// const addImg = new window.Image();
// addImg.src = imageBasePath + flip + 'add.svg';
// const editFlipImg = new window.Image();
// editFlipImg.src = imageBasePath + flip + 'edit.svg';
// const moreImg = new window.Image();
// moreImg.src = imageBasePath + flip + 'more.svg';

/*
 *
 *
 *
 * node
 *
 *
 *
 */

const editNodeImg = new window.Image();
editNodeImg.src = imageBasePath + node + 'edit.svg';
const baretreeImg = new window.Image();
baretreeImg.src = imageBasePath + node + 'baretree.svg';
const pruneImg = new window.Image();
pruneImg.src = imageBasePath + node + 'prune.svg';
const treeImg = new window.Image();
treeImg.src = imageBasePath + node + 'tree.svg';
const dnaImg = new window.Image();
// dnaImg.src = imageBasePath + node + 'dna_strand_layered.svg';
dnaImg.src = imageBasePath + node + 'dna.svg'; //https://binf.snipcademy.com/lessons/dna-sequencing-techniques

const gedcomImg = new window.Image();
// gedcomImg.src = imageBasePath + node + 'dna_strand_layered.svg';
gedcomImg.src = imageBasePath + node + 'gedcom.svg'; //https://binf.snipcademy.com/lessons/dna-sequencing-techniques

/*
 *
 *
 *
 * choices
 *
 *
 *
 */

const brotherImg = new window.Image();
brotherImg.src = imageBasePath + choices + 'brother.svg';
const daughterImg = new window.Image();
daughterImg.src = imageBasePath + choices + 'daughter.svg';
const fatherImg = new window.Image();
fatherImg.src = imageBasePath + choices + 'father.svg';
const motherImg = new window.Image();
motherImg.src = imageBasePath + choices + 'mother.svg';
const partnerImg = new window.Image();
partnerImg.src = imageBasePath + choices + 'partner.svg';
const sisterImg = new window.Image();
sisterImg.src = imageBasePath + choices + 'sister.svg';
const sonImg = new window.Image();
sonImg.src = imageBasePath + choices + 'son.svg';


/*
 *
 *
 *
 * match
 *
 *
 *
 */

const geniImg = new window.Image();
geniImg.src = imageBasePath + match + 'geni.svg';
const recordImg = new window.Image();
recordImg.src = imageBasePath + match + 'record.svg';
const smartImg = new window.Image();
smartImg.src = imageBasePath + match + 'smart.svg';

const rightTipImg = new window.Image();
rightTipImg.src = imageBasePath + move + 'rightTip.svg';

/*
 *
 *
 *
 * move
 *
 *
 *
 */

// const fatherMoveImg = new window.Image();
// const motherMoveImg = new window.Image();
// motherMoveImg.src = imageBasePath + move + 'mother.svg';
// const brotherMoveImg = new window.Image();
// brotherMoveImg.src = imageBasePath + move + 'brother.svg';
// const husbandMoveImg = new window.Image();
// husbandMoveImg.src = imageBasePath + move + 'husband.svg';
// const wifeMoveImg = new window.Image();
// wifeMoveImg.src = imageBasePath + move + 'wife.svg';
// const sisterMoveImg = new window.Image();
// sisterMoveImg.src = imageBasePath + move + 'sister.svg';
// const sonMoveImg = new window.Image();
// sonMoveImg.src = imageBasePath + move + 'son.svg';
// const daughterMoveImg = new window.Image();
// daughterMoveImg.src = imageBasePath + move + 'daughter.svg';



/*
 *
 *
 *
 * old
 *
 *
 *
 */
// const prunetreeImage = new window.Image();
// prunetreeImage.src = imageBasePath + 'prunetree.svg';

const nodeSvgImg = new window.Image();
nodeSvgImg.src = imageBasePath + 'node.svg';

const magnifyImage = new window.Image();
magnifyImage.src = imageBasePath + 'magnify.svg';

const treeImage = new window.Image();
treeImage.src = imageBasePath + 'treematch.svg';

const waringImage = new window.Image();
waringImage.src = imageBasePath + 'warning.svg';

const mergemoveImage = new window.Image();
mergemoveImage.src = imageBasePath + 'more_icons/resolve_duplicates.svg';

const wandImage = new window.Image();
wandImage.src = imageBasePath + 'smartmatch.svg';

const bookImage = new window.Image();
bookImage.src = imageBasePath + 'recordmatch.svg';

const addnodetabImage = new window.Image();
addnodetabImage.src = imageBasePath + `addnodetab.svg?cacheBust=${data.version}`;

const addnodetabYellowImage = new window.Image();
addnodetabYellowImage.src = imageBasePath + `addnodetabYellow.svg?cacheBust=${data.version}`;

const addnodetabGreenImage = new window.Image();
addnodetabGreenImage.src = imageBasePath + `addnodetabGreen.svg?cacheBust=${data.version}`;

const addnodetabRedImage = new window.Image();
addnodetabRedImage.src = imageBasePath + `addnodetabRed.svg?cacheBust=${data.version}`;

const moretabImage = new window.Image();
moretabImage.src = imageBasePath + 'moretab.svg';

const lockTabImg = new window.Image();
lockTabImg.src = imageBasePath + 'locktab.svg';

const nearTabImg = new window.Image();
nearTabImg.src = imageBasePath + 'neartab7.svg';

const invitationImage = new window.Image();
invitationImage.src = imageBasePath + 'invitation.svg';

const deadBannerImage = new window.Image();
deadBannerImage.src = imageBasePath + 'deadBanner.svg';

const presummedDeadBannerImage = new window.Image();
presummedDeadBannerImage.src = imageBasePath + 'presummedDeadBanner.svg';

const nodeSpinnerGif = new window.Image();
nodeSpinnerGif.src = imageBasePath + 'loading.gif';

/*
 ------------------------------------------------
 */

const reloadImage = new window.Image();
reloadImage.src = imageBasePath + 'reload.svg';

// const onImage = new window.Image();
// onImage.src = imageBasePath + 'on.svg';

// const offImage = new window.Image();
// offImage.src = imageBasePath + 'off.svg';

// const verticalImage = new window.Image();
// verticalImage.src = imageBasePath + 'vertical.svg';

// const horizonalImage = new window.Image();
// horizonalImage.src = imageBasePath + 'horizonal.svg';

const treeChartImage = new window.Image();
treeChartImage.src = imageBasePath + 'treechart.svg';

const editImage = new window.Image();
editImage.src = imageBasePath + 'edit.svg';

const addImage = new window.Image();
addImage.src = imageBasePath + 'add.svg';

const ellipsesImage = new window.Image();
ellipsesImage.src = imageBasePath + 'ellipses.svg';


export default {

  // addImg,
  // editFlipImg,
  // moreImg,

  editNodeImg,
  pruneImg,
  baretreeImg,
  treeImg,
  dnaImg,
  gedcomImg,
  lockTabImg,
  nearTabImg,
  rightTipImg,

  brotherImg,
  daughterImg,
  fatherImg,
  motherImg,
  partnerImg,
  sisterImg,
  sonImg,

  geniImg,
  recordImg,
  smartImg,

  bookImage,
  addnodetabImage,
  addnodetabYellowImage,
  addnodetabGreenImage,
  addnodetabRedImage,
  moretabImage,
  invitationImage,
  deadBannerImage,
  presummedDeadBannerImage,
  wandImage,
  treeImage,
  waringImage,
  mergemoveImage,
  // prunetreeImage,
  nodeSvgImg,
  magnifyImage,
  nodeSpinnerGif,
  treeChartImage,
  editImage,
  addImage,
  ellipsesImage,
  reloadImage,
  // onImage,
  // offImage,
  // verticalImage,
  // horizonalImage,
  // fatherMoveImg,
  // motherMoveImg,
  // brotherMoveImg,
  // sisterMoveImg,
  // wifeMoveImg,
  // husbandMoveImg,
  // sonMoveImg,
  // daughterMoveImg,

};
